/**
 * Patient appointment statistics
 * Refined design with golden accents and ZUB/DH breakdown
 */

import { Calendar, CheckCircle, XCircle, Clock, AlertTriangle } from 'lucide-react'
import type { AppointmentStats } from '@/types/patient'

interface PatientStatsProps {
	stats: AppointmentStats
}

export function PatientStats({ stats }: PatientStatsProps) {
	return (
		<div className="rounded-xl bg-white p-6 shadow-sm border border-[#e8e4df]">
			<h2 className="mb-4 text-lg font-semibold text-[#3d3428]">Statistiky termínů</h2>

			<div className="grid grid-cols-2 gap-3 md:grid-cols-5">
				<StatCard
					icon={<Calendar className="h-5 w-5" />}
					label="Celkem"
					value={stats.total}
					color="gold"
				/>
				<StatCard
					icon={<CheckCircle className="h-5 w-5" />}
					label="Absolvované"
					value={stats.attended}
					color="green"
				/>
				<StatCard
					icon={<Clock className="h-5 w-5" />}
					label="Nadcházející"
					value={stats.upcoming}
					color="blue"
				/>
				<StatCard
					icon={<XCircle className="h-5 w-5" />}
					label="Zrušené"
					value={stats.cancelled}
					color="gray"
				/>
				<StatCard
					icon={<AlertTriangle className="h-5 w-5" />}
					label="Nepřišel"
					value={stats.noShow}
					color="red"
				/>
			</div>
		</div>
	)
}

interface StatCardProps {
	icon: React.ReactNode
	label: string
	value: number
	color: 'gold' | 'green' | 'blue' | 'gray' | 'red'
}

const colorClasses = {
	gold: 'bg-[#f5ebe0] text-[#a88544] border-[#e5c896]',
	green: 'bg-emerald-50 text-emerald-600 border-emerald-100',
	blue: 'bg-blue-50 text-blue-600 border-blue-100',
	gray: 'bg-gray-50 text-gray-600 border-gray-100',
	red: 'bg-red-50 text-red-600 border-red-100',
}

function StatCard({ icon, label, value, color }: StatCardProps) {
	return (
		<div className={`rounded-xl p-4 border ${colorClasses[color]}`}>
			<div className="mb-2 opacity-75">{icon}</div>
			<p className="text-2xl font-bold">{value}</p>
			<p className="text-xs opacity-75">{label}</p>
		</div>
	)
}
